var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-layout"},[_c('a-breadcrumb',_vm._l((_vm.matched),function(item){return _c('a-breadcrumb-item',{key:item.path},[_vm._v(_vm._s(item.meta.title))])}),1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }